import { render, staticRenderFns } from "./fotter.vue?vue&type=template&id=57f31030&scoped=true&"
import script from "./fotter.vue?vue&type=script&lang=js&"
export * from "./fotter.vue?vue&type=script&lang=js&"
import style0 from "./fotter.vue?vue&type=style&index=0&id=57f31030&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f31030",
  null
  
)

export default component.exports